var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"8"}},[_c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.texto)+" ")])]),_c('v-col',{attrs:{"cols":"4"}},[_c('h3',[_vm._v(_vm._s(_vm.tiempo))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }